import { render, staticRenderFns } from "./product-criteria.vue?vue&type=template&id=06b2d014&scoped=true&"
import script from "./product-criteria.vue?vue&type=script&lang=js&"
export * from "./product-criteria.vue?vue&type=script&lang=js&"
import style0 from "./product-criteria.vue?vue&type=style&index=0&id=06b2d014&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b2d014",
  null
  
)

export default component.exports